import {mapFilterTypeToTealium} from '../MyTeamsReport.util';

import {buildMyTeamsFiltersPayload} from './buildMyTeamsFiltersPayload.util';
import {MyTeamsFilters} from './myTeamsFilterDomain.util';

type Params = {
  updatedFilters: MyTeamsFilters;
  newFrontlineOnly?: boolean;
  defaultNewCoachesKey: string;
  ffTeamsOrgSR: boolean;
};

const normalizeRank = (rank: string[] | string | undefined): string[] => {
  if (!rank) return [];
  if (Array.isArray(rank)) return rank;
  try {
    return JSON.parse(rank);
  } catch {
    return [];
  }
};

export const buildFilterAnalyticsPayload = ({
  updatedFilters,
  newFrontlineOnly,
  defaultNewCoachesKey,
  ffTeamsOrgSR,
}: Params) => {
  return buildMyTeamsFiltersPayload({
    frontlineOnly: newFrontlineOnly,
    frontlineAction: newFrontlineOnly ? 'Frontline_add' : 'Frontline_remove',

    rank: normalizeRank(updatedFilters.rank).map((r: any) =>
      mapFilterTypeToTealium('rank', r, ffTeamsOrgSR),
    ),

    fibc: mapFilterTypeToTealium(
      'fibc',
      updatedFilters.fibc || 'Any',
      ffTeamsOrgSR,
    ),

    period: mapFilterTypeToTealium(
      'new_coach',
      updatedFilters.period || defaultNewCoachesKey,
      ffTeamsOrgSR,
    ),

    periodDefaultValue: defaultNewCoachesKey,
  });
};
